import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "../../utils/toast";
import WorkWithUs from "../../components/sections/WorkWithUs";

const Signup = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    phone: "",
    alternative_phone: "",
    email: "",
    date_of_birth: "",
    gender: "",
    use_whatsapp_otp: false,
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = {};
    if (!formData.first_name.trim()) {
      validationErrors.first_name = "First name is required";
    } else if (!/^[a-zA-Z\s]+$/.test(formData.first_name.trim())) {
      validationErrors.first_name = "First name may only contain letters.";
    }
    if (!formData.last_name.trim()) {
      validationErrors.last_name = "Last name is required";
    } else if (!/^[a-zA-Z\s]+$/.test(formData.last_name.trim())) {
      validationErrors.last_name = "Last name may only contain letters.";
    }
    if (!formData.phone.trim()) {
      validationErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      validationErrors.phone = "Phone number must be 10 digits";
    }

    if (
      formData.alternative_phone &&
      !/^\d{10}$/.test(formData.alternative_phone)
    ) {
      validationErrors.alternative_phone = "Alternate number must be 10 digits";
    }

    if (
      formData.email &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
    ) {
      validationErrors.email = "Please enter a valid email address";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});

    setLoading(true);

    try {
      const data = new FormData();
      data.append("first_name", formData.first_name);
      data.append("last_name", formData.last_name);
      data.append("phone", formData.phone);
      data.append("alternative_phone", formData.alternative_phone);
      data.append("email", formData.email);
      data.append("date_of_birth", formData.date_of_birth);
      data.append("gender", formData.gender);
      data.append("use_whatsapp_otp", formData.use_whatsapp_otp ? 1 : 0);
      data.append("source", "website");
      const response = await axios.post(
        `${process.env.REACT_APP_APP_DOMAIN}/api/customer/signup`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.data.status === true) {
        toast.success(response.data.message || "OTP sent successfully!");
        navigate("/signup-otp", {
          state: { phone: formData.phone, from: location.state?.from },
        });
      } else {
        toast.error(response.data.message || "Signup failed");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.errors) {
        const errors = error.response.data.errors;
        Object.keys(errors).forEach((key) => {
          toast.error(errors[key][0]);
        });
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Server error. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="login_wrap">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="login_formMain">
                <div className="loginForm_inner">
                  <h2>Create Account</h2>

                  {/* Profile Image */}
                  {/* <div className="text-center mb-4">
                    <div
                      onClick={() => imageRef.current.click()}
                      style={{
                        width: "90px",
                        height: "90px",
                        borderRadius: "50%",
                        border: "2px dashed #ccc",
                        margin: "0 auto",
                        cursor: "pointer",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#f8f8f8",
                      }}
                    >
                      {imagePreview ? (
                        <img
                          src={imagePreview}
                          alt="Profile"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <span style={{ fontSize: "12px", color: "#999" }}>
                          Upload Photo
                        </span>
                      )}
                    </div>
                    <input
                      type="file"
                      ref={imageRef}
                      accept="image/jpeg,image/png,image/jpg,image/gif"
                      onChange={handleImageChange}
                      style={{ display: "none" }}
                    />
                  </div> */}

                  {/* First Name & Last Name */}
                  <div className="row">
                    <div className="col-md-6 form-group mb-4">
                      <input
                        type="text"
                        name="first_name"
                        className={`form-control ${errors.first_name ? "is-invalid" : ""}`}
                        placeholder="First Name *"
                        value={formData.first_name}
                        onChange={handleChange}
                      />
                      {errors.first_name && (
                        <div className="invalid-feedback">{errors.first_name}</div>
                      )}
                    </div>
                    <div className="col-md-6 form-group mb-4">
                      <input
                        type="text"
                        name="last_name"
                        className={`form-control ${errors.last_name ? "is-invalid" : ""}`}
                        placeholder="Last Name *"
                        value={formData.last_name}
                        onChange={handleChange}
                      />
                      {errors.last_name && (
                        <div className="invalid-feedback">{errors.last_name}</div>
                      )}
                    </div>
                  </div>

                  {/* Phone & Alternate Number */}
                  <div className="row">
                    <div className="col-md-6 form-group mb-4">
                      <input
                        type="text"
                        name="phone"
                        className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                        placeholder="Phone Number *"
                        value={formData.phone}
                        onChange={handleChange}
                        maxLength={10}
                      />
                      {errors.phone && (
                        <div className="invalid-feedback">{errors.phone}</div>
                      )}
                    </div>
                    <div className="col-md-6 form-group mb-4">
                      <input
                        type="text"
                        name="alternative_phone"
                        className={`form-control ${errors.alternative_phone ? "is-invalid" : ""}`}
                        placeholder="Alternate Number"
                        value={formData.alternative_phone}
                        onChange={handleChange}
                        maxLength={10}
                      />
                      {errors.alternative_phone && (
                        <div className="invalid-feedback">{errors.alternative_phone}</div>
                      )}
                    </div>
                  </div>

                  {/* Email */}
                  <div className="form-group mb-4">
                    <input
                      type="email"
                      name="email"
                      className={`form-control ${errors.email ? "is-invalid" : ""}`}
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <div className="invalid-feedback">{errors.email}</div>
                    )}
                  </div>

                  {/* Date of Birth & Gender */}
                  <div className="row">
                    <div className="col-md-6 form-group mb-4">
                      <label className="mb-0" style={{ fontWeight: "500" }}>
                        Date of Birth
                      </label>
                      <input
                        type="date"
                        name="date_of_birth"
                        className="form-control"
                        value={formData.date_of_birth}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 form-group mb-4">
                      <label className="mb-0" style={{ fontWeight: "500" }}>
                        Gender
                      </label>
                      <div className="d-flex gap-3 mt-2">
                        <div className="d-flex align-items-center gap-1">
                          <input
                            type="radio"
                            name="gender"
                            id="genderMale"
                            className="form-check-input"
                            value="male"
                            checked={formData.gender === "male"}
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="genderMale"
                          >
                            Male
                          </label>
                        </div>
                        <div className="d-flex align-items-center gap-1">
                          <input
                            type="radio"
                            name="gender"
                            id="genderFemale"
                            className="form-check-input"
                            value="female"
                            checked={formData.gender === "female"}
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="genderFemale"
                          >
                            Female
                          </label>
                        </div>
                        <div className="d-flex align-items-center gap-1">
                          <input
                            type="radio"
                            name="gender"
                            id="genderOther"
                            className="form-check-input"
                            value="other"
                            checked={formData.gender === "other"}
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="genderFemale"
                          >
                            Other
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group mb-4">
                    <div className="form-check d-flex align-items-center">
                      <input
                        type="checkbox"
                        name="use_whatsapp_otp"
                        id="use_whatsapp_otp"
                        className="form-check-input"
                        style={{ width: "14px", height: "14px" }}
                        checked={formData.use_whatsapp_otp}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            use_whatsapp_otp: e.target.checked,
                          })
                        }
                      />
                      <label htmlFor="use_whatsapp_otp" className="ms-2 mb-0" style={{ fontSize: "14px" }}>
                        If your mobile is on DND, please select WhatsApp OTP option
                      </label>
                    </div>
                  </div>
                  <div className="login_btn mb-4">
                    <button
                      className="btn"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading ? "Sending OTP..." : "Generate OTP"}
                    </button>
                  </div>

                  <div className="new_user">
                    <p>
                      Already have an account? <Link to="/login">Log In</Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <WorkWithUs />
      <ToastContainer />
    </>
  );
};

export default Signup;
